/* ============================================================
   MY RARE AURA — PHASE 7 CUSTOMER ACCOUNT
   File: assets/aurelle-account.js

   Controls:
   1. Wishlist count on the member hub
   2. Recently viewed product rendering
   3. Safe localStorage parsing
   4. Cross-tab updates

   Does not modify cart or cart drawer behavior.
   ============================================================ */

(function () {
  'use strict';

  var WISHLIST_KEYS = [
    'aurelleWishlist',
    'aurelle_wishlist',
    'house_of_aurelle_wishlist'
  ];

  var RECENT_KEYS = [
    'aurelleRecentlyViewed',
    'aurelle_recently_viewed',
    'houseOfAurelleRecentlyViewed'
  ];

  function qs(selector, root) {
    return (root || document).querySelector(selector);
  }

  function qsa(selector, root) {
    return Array.prototype.slice.call(
      (root || document).querySelectorAll(selector)
    );
  }

  function readArray(keys) {
    var value = [];

    keys.some(function (key) {
      var raw = localStorage.getItem(key);
      if (!raw) return false;

      try {
        var parsed = JSON.parse(raw);
        if (Array.isArray(parsed)) {
          value = parsed;
          return true;
        }
      } catch (error) {}

      return false;
    });

    return value;
  }

  function escapeHtml(value) {
    return String(value || '').replace(/[&<>"']/g, function (character) {
      return {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#039;'
      }[character];
    });
  }

  function normalizeUrl(url) {
    if (!url) return '#';
    return String(url);
  }

  function normalizeImage(image) {
    if (!image) return '';
    if (typeof image === 'string') return image;
    return image.url || image.src || '';
  }

  function updateWishlistCount() {
    var items = readArray(WISHLIST_KEYS);

    qsa('[data-aurelle-account-wishlist-count]').forEach(function (element) {
      element.textContent = items.length;
    });
  }

  function normalizeRecentItem(item) {
    if (!item) return null;

    return {
      title: item.title || item.name || 'My Rare Aura',
      url: normalizeUrl(item.url || item.href),
      image: normalizeImage(item.image || item.featured_image || item.src),
      price: item.price || item.priceText || ''
    };
  }

  function recentCard(item) {
    var image = item.image
      ? '<div class="aurelle-account__recent-image">' +
          '<img src="' + escapeHtml(item.image) + '" width="700" height="933" alt="' +
          escapeHtml(item.title) + '" loading="lazy">' +
        '</div>'
      : '<div class="aurelle-account__recent-image" aria-hidden="true"></div>';

    return (
      '<a class="aurelle-account__recent-card" href="' + escapeHtml(item.url) + '">' +
        image +
        '<h3>' + escapeHtml(item.title) + '</h3>' +
        (item.price ? '<p>' + escapeHtml(item.price) + '</p>' : '') +
      '</a>'
    );
  }

  function renderRecentlyViewed() {
    var grid = qs('[data-aurelle-account-recent-grid]');
    var empty = qs('[data-aurelle-account-recent-empty]');

    if (!grid) return;

    var rawItems = readArray(RECENT_KEYS);
    var seen = {};

    var items = rawItems
      .map(normalizeRecentItem)
      .filter(function (item) {
        if (!item || !item.url || item.url === '#') return false;
        if (seen[item.url]) return false;
        seen[item.url] = true;
        return true;
      })
      .slice(0, 4);

    grid.innerHTML = '';

    if (!items.length) {
      grid.hidden = true;
      if (empty) empty.hidden = false;
      return;
    }

    grid.hidden = false;
    if (empty) empty.hidden = true;
    grid.innerHTML = items.map(recentCard).join('');
  }

  function init() {
    if (!qs('[data-aurelle-account-page]')) return;
    updateWishlistCount();
    renderRecentlyViewed();
  }

  document.addEventListener('aurelle:wishlist-updated', updateWishlistCount);

  window.addEventListener('storage', function (event) {
    if (WISHLIST_KEYS.indexOf(event.key) !== -1) updateWishlistCount();
    if (RECENT_KEYS.indexOf(event.key) !== -1) renderRecentlyViewed();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
